import { useLanguage } from '../../../context/LanguageContext';

// Country dot positions as percentage of image width/height
const countryDots = [
  {
    id: 'estonia',    label: 'Estonia',
    top: '49.0%', left: '52.5%',
    mTop: '49.6%', mLeft: '53.1%',         // mobile: half distance down-right
    color: '#00E5FF'
  },
  {
    id: 'poland',     label: 'Poland',
    top: '52.65%', left: '50.75%',
    mTop: '52.65%', mLeft: '50.75%',
    color: '#00E5FF'
  },
  {
    id: 'germany',    label: 'Germany',
    top: '52.5%', left: '48.5%',
    mTop: '53.7%', mLeft: '48.5%',
    color: '#00E5FF'
  },
  {
    id: 'egypt',      label: 'Egypt',
    top: '63.65%', left: '53.5%',
    mTop: '63.65%', mLeft: '55.2%',
    color: '#00E5FF'
  },
  {
    id: 'uzbekistan', label: 'Uzbekistan',
    top: '57.5%', left: '62.5%',
    mTop: '57.5%', mLeft: '67.38%',        // mobile: moved left
    color: '#00E5FF'
  },
  {
    id: 'qatar',      label: 'Qatar',
    top: '65.15%', left: '59.0%',
    mTop: '65.15%', mLeft: '62.06%',       // mobile: moved left
    color: '#00E5FF'
  },
];

export default function Regions() {
  const { t } = useLanguage();

  const regions = [
    { name: t('regions.europe'), subtitle: t('regions.europeSubtitle') },
    { name: t('regions.middleEast'), subtitle: t('regions.middleEastSubtitle') },
    { name: t('regions.estonia'), subtitle: t('regions.estoniaSubtitle') },
    { name: t('regions.egypt'), subtitle: t('regions.egyptSubtitle') },
    { name: t('regions.centralAsia'), subtitle: t('regions.centralAsiaSubtitle') },
  ];

  return (
    <section id="regions" className="relative w-full overflow-hidden bg-[#0D1B2E]">
      <style>{`
        @keyframes pulse-ring {
          0%   { transform: scale(0.6); opacity: 0.9; }
          100% { transform: scale(2.6); opacity: 0; }
        }
        @keyframes pulse-ring2 {
          0%   { transform: scale(0.6); opacity: 0.6; }
          100% { transform: scale(2.0); opacity: 0; }
        }
        @keyframes dot-glow {
          0%, 100% { box-shadow: 0 0 6px 2px #00E5FF, 0 0 12px 4px #00E5FFaa; }
          50%       { box-shadow: 0 0 12px 4px #00E5FF, 0 0 24px 8px #00E5FFcc; }
        }
        .pulse-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 2px solid #00E5FF;
          animation: pulse-ring 2s ease-out infinite;
        }
        .pulse-ring2 {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          border: 1.5px solid #00E5FFaa;
          animation: pulse-ring2 2s ease-out infinite;
          animation-delay: 0.5s;
        }
        .dot-core {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00E5FF;
          animation: dot-glow 2s ease-in-out infinite;
          position: relative;
          z-index: 2;
        }
      `}</style>

      <div className="relative w-full" style={{ minHeight: '420px' }}>
        <img
          src="https://public.readdy.ai/ai/img_res/edited_c3582d2215807bd3a8706a64a198561e_a5c0e91c.jpg"
          alt="Regions We Serve - World Map"
          className="w-full h-full object-cover object-top"
          style={{ display: 'block', minHeight: '420px' }}
        />

        {/* Animated country dots */}
        {countryDots.map((dot) => (
          <div key={dot.id}>
            {/* Desktop */}
            <div
              className="absolute hidden sm:block"
              style={{ top: dot.top, left: dot.left, transform: 'translate(-50%, -50%)', zIndex: 10 }}
              title={dot.label}
            >
              <div style={{ position: 'relative', width: '8px', height: '8px' }}>
                <div className="pulse-ring" />
                <div className="pulse-ring2" />
                <div className="dot-core" />
              </div>
            </div>
            {/* Mobile */}
            <div
              className="absolute block sm:hidden"
              style={{ top: dot.mTop, left: dot.mLeft, transform: 'translate(-50%, -50%)', zIndex: 10 }}
              title={dot.label}
            >
              <div style={{ position: 'relative', width: '8px', height: '8px' }}>
                <div className="pulse-ring" />
                <div className="pulse-ring2" />
                <div className="dot-core" />
              </div>
            </div>
          </div>
        ))}

        <div className="absolute inset-0 flex flex-col items-center justify-start pt-8 sm:pt-10 md:pt-12 px-4">
          <div className="inline-block px-5 py-1.5 bg-white/10 border border-white/20 text-white/80 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4 tracking-widest uppercase">
            {t('regions.badge')}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white text-center leading-tight drop-shadow-lg">
            {t('regions.heading')}
          </h2>
        </div>
      </div>

      {/* Region labels */}
      <div className="w-full border-t border-white/10">
        <div className="max-w-5xl mx-auto px-6 py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-6 md:gap-0 md:divide-x md:divide-white/10">
          {regions.map((region) => (
            <div key={region.name} className="flex flex-col items-center text-center px-4">
              <span className="text-white text-base font-semibold tracking-wide mb-1">
                {region.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
